import orgAuthEmployee from "./orgAuthEmployee";
import orgAuth from "./orgAuth";


export default {
    orgAuthEmployee,
    orgAuth
}